import { render, staticRenderFns } from "./authorProductAnalysis.vue?vue&type=template&id=416ada6c&scoped=true"
import script from "./authorProductAnalysis.vue?vue&type=script&lang=js"
export * from "./authorProductAnalysis.vue?vue&type=script&lang=js"
import style0 from "./authorProductAnalysis.vue?vue&type=style&index=0&id=416ada6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416ada6c",
  null
  
)

export default component.exports